import { useLocation, useNavigate } from 'react-router-dom';

export const useNotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const homePagaHandler = () => {
    navigate(`${lang}/home-page`);
  };

  return {
    homePagaHandler,
  };
};

export default useNotFoundPage;
